import axios from "axios";
import { GetPublicPaymentRequestResponse } from "./types";

const baseURL = import.meta.env.VITE_API_BASE_URL ?? "";

// Public lookup — uses a raw axios call (no auth headers, no company UUID
// injection) since the token is the credential and the caller is
// unauthenticated.
export async function getPublicPaymentRequest(
  token: string,
): Promise<GetPublicPaymentRequestResponse> {
  const response = await axios.get(
    `${baseURL}/api/public/payment-requests/${encodeURIComponent(token)}`,
  );
  return response.data?.data ?? response.data;
}
